<script setup lang="ts">
import { ref } from 'vue'
import { useNavigation } from './useNavigation'

const { getLink: $getLink, gotoOnClick: $gotoOnClick } = useNavigation()

const isOpen = ref(false)
const $open = () => {
  isOpen.value = true
}

defineExpose({ $open })
</script>

<template>
  <v-rich-modal v-model="isOpen" force-desktop title="Звёздочки">
    <div class="d-flex" style="max-width: min(90vw, 650px)">
      <div class="pa-2" style="position: relative">
        <v-icon size="96">3d-star</v-icon>
        <v-icon size="24" class="student-stars-sparkle">mdi-star-four-points</v-icon>
        <v-icon size="24" class="student-stars-sparkle">mdi-star-four-points</v-icon>
        <v-icon size="24" class="student-stars-sparkle">mdi-star-four-points</v-icon>
      </div>

      <span class="ma-1" />

      <div class="ml-2 flex-spacer">
        <p class="text-title">Звёздочки можно заработать:</p>
        <ul class="native-ul">
          <li class="mt-1">
            <a
              class="blue-text text-body-bold d-inline-flex align-center"
              :href="$getLink({ tab: 'video' })"
              @click="
                event => {
                  $gotoOnClick(event)
                  isOpen = false
                }
              "
            >
              При просмотре видеоурока
              <v-icon size="16" class="ml-half">mdi-open-in-new</v-icon>:
            </a>
            в каждый урок включены 3 мини-задания, за выполнение которых можно получить по 1 звёздочке. Эти задания
            доступны, начиная со второго просмотра урока.
          </li>
          <li class="mt-1">
            <a
              class="blue-text text-body-bold d-inline-flex align-center"
              :href="$getLink({ tab: 'audio' })"
              @click="
                event => {
                  $gotoOnClick(event)
                  isOpen = false
                }
              "
            >
              В ночном режиме
              <v-icon size="16" class="ml-half">mdi-open-in-new</v-icon>:
            </a>
            каждый день с 20:00 до 24:00 в разделе &laquo;Аудиоуроки&raquo; доступен ночной режим, в котором можно
            получить 1 звёздочку за прослушивание аудиоурока. <b>Рекомендуем использовать ночной режим перед сном.</b>
          </li>
        </ul>

        <p class="mt-2">
          Звёздочки можно потратить в
          <a
            class="blue-text text-body-bold d-inline-flex align-center"
            :href="$getLink({ tab: 'shop' })"
            @click="
              event => {
                $gotoOnClick(event)
                isOpen = false
              }
            "
          >
            Магазине аватара
            <v-icon size="16" class="ml-half">mdi-open-in-new</v-icon>
          </a>
        </p>
      </div>
    </div>
  </v-rich-modal>
</template>

<style lang="scss" scoped>
.student-stars-sparkle {
  animation: sparkle 2s ease infinite;
  opacity: 0;
  color: white;
  position: absolute;

  top: 45px;
  left: 36px;

  & + & {
    top: 83px;
    left: 71px;
    animation-delay: 1s;
  }

  &:last-child {
    top: 38px;
    left: 81px;
    animation-delay: 0.5s;
  }
}

@keyframes sparkle {
  0% {
    opacity: 0;
    transform: rotate(0deg);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(180deg);
  }
}
</style>
